import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '../app/app.module';
import { environment } from '../environments/environment';

if (environment.production) enableProdMode();

(async () => {
    const appsettings = await fetch("./assets/appsettings.json");
    const config = await appsettings.json();

    environment["apiBase"] = config.apiBase;
    environment["useRecaptcha"] = config.useRecaptcha;
    if (environment.useRecaptcha === "false") environment.useRecaptcha = false;
    environment["recaptchaSitekey"] = config.recaptchaSitekey;
    environment["production"] = config.production;
    environment["cardPointeUrl"] = config.cardPointeUrl;

    // this is the easy (bad) way
    if (environment.apiBase.indexOf("prod") > -1) environment.production = true;

    platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
})();
